import axios from "axios";
import { IGetCrossingLinesRequestData, IGetCrossingLinesResponseData } from "./interfaces";
import { BASE_API_URL, getAPIHeaderOptions } from "../../utils/apiUtils";

const getCrossingLines = (requestData: IGetCrossingLinesRequestData): Promise<IGetCrossingLinesResponseData> => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${BASE_API_URL}/cameraconfig/crossing_lines`, requestData, { headers: getAPIHeaderOptions(true) })
			.then((response) => {
				if (response.data) resolve(response.data);
				else reject("Something went wrong");
			})
			.catch((error) => reject(error?.response?.data?.detail));
	});
};

const canvasServices = { getCrossingLines };

export default canvasServices;
